import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { properties } from '../../../../environments/properties';
import { AuthService } from "../../../shared/services/auth.service";
import { SubscriptionService } from "../../../shared/services/subscription.service";
import { _windowUtil } from '../../../shared/utils/ui-utils';

declare const AB: any;
@Component({
  selector: 'manage-subscription-summary',
  templateUrl: './manage-subscription.component.html',
  styleUrls: ['./manage-subscription.component.scss'],
  providers: [SubscriptionService]
})
export class ManageSubscriptionComponent implements OnInit {

  public userSubscriptionDetails: any;
  freshpassSubscriptionType: string;
  userInfo: any;
  tenderInfo: any;
  showTenders = false;
  showTermsSection = true;
  lifeSavings: number;
  currentEnvironment;
  isFPTenderAvailable = false;
  isTrialPlan = false
  displaySubTypeLink = false;
  pageName = properties.freshpassData.manageText;

  snapFlagEnabled: boolean = properties.featureFlags.enableSnap;

  MONTHLY_PLAN_NAME: string = properties.manage.MONTHLY;
  ANNUAL_PLAN_NAME: string = properties.manage.ANNUAL;
  suspendedGovElibilityText: string = properties.freshpassData.suspendedGovElibilityText;
  govAssistanceElibilityText: string = properties.freshpassData.govAssistanceElibilityText;
  snapVerificationURL_UCA: string = properties.snapVerificationURL_UCA;

  properties = properties;


  public windowUtil = _windowUtil(window);

  constructor(public subscriptionService: SubscriptionService,
    public authService: AuthService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private titleService: Title,
  ) {
    this.setTitle(this.properties.manage.FRESHPASS_MANAGE_SUBSCRIPTION);
  }

  ngOnInit() {
    this.setProps()
    this.activeRoute.data.subscribe({
      next: (data) => {
        let isSessionValid = this.authService.isTokenValidForSession(data.tokenObject);
        if (isSessionValid) {
          const sessionData = { ...(data.tokenObject), authToken: data.tokenObject['SWY_SHOP_TOKEN'] };
          if (sessionData) {
            this.userInfo = sessionData;
            this.initSubscribes();
            this.checkNotifyMessage();
          }
        } else {
          this.authService.redirectToSSO(data.tokenObject);
        }
      },
      error: (err) => {
        this.authService.redirectToSSO({});
      }
    });
  }

  setProps(): void {
    this.currentEnvironment = this.subscriptionService.getEnvironment();
  }

  setTitle(newTitle: string): void {
    this.titleService.setTitle(newTitle);
  }

  initSubscribes() {
    this.subscriptionService.getUserSubscriptionDetails(this.userInfo, this.currentEnvironment).subscribe((data) => {
      if (data && data.Data) {
        this.redirectIfNotPrimaryUser(data.Data);
        this.setUserSubscriptionDetails(data.Data)
      }
    }, error => {
      if (error) {
        if (error?.error && error?.error?.errorCode) {
          this.handleErrorCode(error.error.errorCode)
        }
      } else {
        this.redirectToSubscribe();
      }
    })
  }

  setUserSubscriptionDetails(userSubDetails) {
    this.userSubscriptionDetails = userSubDetails;
    this.lifeSavings = this.userSubscriptionDetails?.lifeSavings || 0;
    this.isTrialPlan = this.subscriptionService.getTrialPlanStatus(this.userSubscriptionDetails);
    if(this.userSubscriptionDetails?.isPrimaryFreshPassUser === false) {
      this.router.navigate([this.properties.urlPath.CONFIRMATION_PATH]);
    }
    if (this.userSubscriptionDetails && this.userSubscriptionDetails.subscriptionStatus && this.userSubscriptionDetails.subscriptionStatus !== 'CANCELLED') {
      this.displayCurrentPaymentComponent()
      this.sendMessageCenterData();
      this.updateAnalyticsSubscriptionInfo();
    } else {
      this.redirectToSubscribe();
    }
  }

  displayCurrentPaymentComponent() {
    if (this.userSubscriptionDetails.subscriptionStatus !== this.properties.manage.PENDING_CANCELLATION) {
      this.setActiveUserTendersDetails();
    } else {
      this.showTermsSection = false;
    }
  }

  setActiveUserTendersDetails() {
    if (this.userInfo && this.currentEnvironment) {
      this.subscriptionService.getTenders(this.userInfo, this.currentEnvironment).subscribe((tenderData) => {
        this.showTenders = true;
        if (tenderData && tenderData.paymentMethods && tenderData.paymentMethods.length > 0) {
          tenderData.paymentMethods.forEach((tenderObj) => {
            if (tenderObj.primaryPurposes.includes(this.properties.manage.DELIVERY_SUBSCRIPTION)) {
              this.isFPTenderAvailable = true;
              this.tenderInfo = tenderObj;
              let normalizedMaskedLength = this.tenderInfo.maskedNumber.length;
              if (normalizedMaskedLength > 4) {
                let temp = this.tenderInfo.maskedNumber.slice(normalizedMaskedLength - 5, normalizedMaskedLength - 1);
                this.tenderInfo.maskedNumber = temp;
              }
            } else {
              this.isFPTenderAvailable = false;
            }
          });
        }
      });
    }
  }

  sendMessageCenterData() {
    if (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.ACTIVE) {
      this.sendActiveStatusMessage();
    }
    if (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.TRIAL) {
      this.sendTrialMessageCenterData();
    }
    if ((this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PENDING_ACTIVATION) && (this.userSubscriptionDetails.status != this.properties.manage.SUSPENDED) &&
      (this.userSubscriptionDetails.pendingRenewalDate && this.userSubscriptionDetails.pendingFee && this.userSubscriptionDetails.pendingSubsCode)) {
      if (this.userSubscriptionDetails.pendingDiscountType.toLowerCase() === this.properties.prechurn.retentionDiscountType) {
        this.sendPreChurnDiscountSuccessStatusMessage();
      } else {
        this.sendPendingActivationStatusMessage();
      }
    }
    if ((this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PROCESSING) &&
      (this.userSubscriptionDetails.renewalDate && this.userSubscriptionDetails.fee && this.userSubscriptionDetails.subscriptionCode)) {
      this.sendProcessingStatusMessage()
    }
    if (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PENDING_CANCELLATION) {
      this.showTenders = false;
      this.sendPendingCancellationStatusMessage();
    }
    if (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.SUSPENDED.toUpperCase() ||
      (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PENDING_ACTIVATION && this.userSubscriptionDetails.status === this.properties.manage.SUSPENDED)) {
      this.sendSuspendedStatusMessage();
    }
    //If user is snap verified and PromoInfo is coming. it will take presedence over other messages
    if (this.userSubscriptionDetails.isSheerVerified && this.userSubscriptionDetails.promoInfo) {
      this.sendSnapVerifiedMessage();
    }
  }

  sendActiveStatusMessage() {
    this.sendSnapVerifiedMessage();
  }

  sendSnapVerifiedMessage() {
    if (this.snapFlagEnabled) {
      if (this.userSubscriptionDetails.isSheerVerified && this.userSubscriptionDetails.promoInfo) {
        this.subscriptionService.messageCenterData$.next(
          {
            value: this.userSubscriptionDetails.promoInfo,
            isErrorMsg: false,
            isVerifiedPromoMessage: true
          });
      }
    }
  }

  sendPreChurnDiscountSuccessStatusMessage() {
    this.subscriptionService.messageCenterData$.next(
      {
        value: this.properties.prechurn.successStatusMessage.replace('{pendingFee}', this.userSubscriptionDetails.pendingFee).replace('{pendingPricingDetail}', this.userSubscriptionDetails.pendingPricingDetail),
        isErrorMsg: false,
        isVerifiedPromoMessage: true
      });
  }

  sendTrialMessageCenterData() {
    let expirationPlanType = this.getExpirationPlanType();

    this.subscriptionService.messageCenterData$.next(
      {
        value: this.properties.manage.YOUR_FREE_TRIAL_ENDS_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails.curentPlanExpiryDate) + ', ' +
          this.properties.manage.YOU_LL_BE_AUTOMATICALLY_ENROLLED_INTO_THE + ' <b>' + expirationPlanType + '</b> ' + this.properties.manage.FRESH_PASS_PLAN_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails.renewalDate) + '.',
        isErrorMsg: false,
      }
    );
  }

  sendPendingActivationStatusMessage() {
    let planType = this.getPlanType(this.userSubscriptionDetails.pendingSubsCode)
    if (this.isTrialPlan) {
      this.subscriptionService.messageCenterData$.next(
        {
          value: this.properties.manage.YOUR_FREE_TRIAL_ENDS_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails.curentPlanExpiryDate) + ', ' + this.properties.manage.YOU_LL_BE_AUTOMATICALLY_ENROLLED_INTO_THE + '<b>' + planType + '</b> ' + this.properties.manage.FRESH_PASS_PLAN_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails.pendingRenewalDate) + '.',
          isErrorMsg: false,
        });
    } else {
      if (this.snapFlagEnabled) {
        //message center message for SNAP
        let pendingFee = this.removeTrailingZeroesInFee(this.userSubscriptionDetails.pendingFee);
        let pendingPricingDetail = this.userSubscriptionDetails.pendingPricingDetail.replace(/\s/g, '');

        let pendingActivationStatusMessage = properties.freshpassData.pendingActivationStatusMessage.replace('{pendingFee}', pendingFee).replace('{pendingPricingDetail}', pendingPricingDetail);
        this.subscriptionService.messageCenterData$.next(
          {
            value: pendingActivationStatusMessage,
            isErrorMsg: false,
          });
      } else {
        this.subscriptionService.messageCenterData$.next(
          {
            value: this.properties.manage.YOUR + this.userSubscriptionDetails.pendingFee + ' <b>' + planType + '</b> ' + this.properties.manage.FRESH_PASS_PLAN_WILL_BECOME_EFFECTIVE_AFTER_THE_CURRENT_PLAN_EXPIRES_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails.curentPlanExpiryDate),
            isErrorMsg: false,
          });
      }
    }
  }

  sendProcessingStatusMessage() {
    let planType = this.getPlanType(this.userSubscriptionDetails.subscriptionCode);
    if (this.isTrialPlan) {
      this.subscriptionService.messageCenterData$.next(
        {
          value: this.properties.manage.YOUR_FREE_TRIAL_ENDS_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails.curentPlanExpiryDate) + ', ' + this.properties.manage.YOU_LL_BE_AUTOMATICALLY_ENROLLED_INTO_THE + ' <b>' + planType + '</b> ' + this.properties.manage.FRESH_PASS_PLAN_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails.renewalDate) + '.',
          isErrorMsg: false,
        });
    } else {
      if (this.snapFlagEnabled) {
        //message center message for SNAP
        let pendingFee = this.removeTrailingZeroesInFee(this.userSubscriptionDetails.pendingFee);
        let pendingPricingDetail = this.userSubscriptionDetails.pendingPricingDetail.replace(/\s/g, '');

        let pendingActivationStatusMessage = properties.freshpassData.pendingActivationStatusMessage.replace('{pendingFee}', pendingFee).replace('{pendingPricingDetail}', pendingPricingDetail);
        this.subscriptionService.messageCenterData$.next(
          {
            value: pendingActivationStatusMessage,
            isErrorMsg: false,
          });
      } else {
        this.subscriptionService.messageCenterData$.next(
          {
            value: this.properties.manage.YOUR + this.userSubscriptionDetails.fee + ' <b>' + planType + '</b>' + this.properties.manage.FRESH_PASS_PLAN_WILL_BECOME_EFFECTIVE_AFTER_THE_CURRENT_PLAN_EXPIRES_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails.curentPlanExpiryDate),
            isErrorMsg: false,
          });
      }
    }
  }

  sendPendingCancellationStatusMessage() {
    if (this.isTrialPlan) {
      this.subscriptionService.messageCenterData$.next(
        {
          value: this.properties.manage.YOUR_CURRENT_FRESH_PASS_PLAN_HAS_BEEN + ' ' + this.subscriptionService.convertDate(this.userSubscriptionDetails.curentPlanExpiryDate) + ', ' + this.properties.manage.YOU_CAN_STILL_CONTINUE_TO_USE_FRESH_PASS_UNTIL + this.subscriptionService.convertDate(this.userSubscriptionDetails.curentPlanExpiryDate) + '.',
          isErrorMsg: false,
        });
    } else {
      this.subscriptionService.messageCenterData$.next(
        {
          value: this.properties.manage.YOUR_CURRENT_FRESH_PASS_PLAN + ' ' + this.subscriptionService.convertDate(this.userSubscriptionDetails.curentPlanExpiryDate) + '.',
          isErrorMsg: false,
        });
    }
  }

  sendSuspendedStatusMessage() {
    if (this.snapFlagEnabled && this.userSubscriptionDetails?.isPromoExpired && this.userSubscriptionDetails?.promoInfo.includes(this.govAssistanceElibilityText)) {
      const reverifySnapMessage = this.suspendedGovElibilityText + `<a href="${this.snapVerificationURL_UCA}" role="button" class='verificationLink' tabindex="0">` + this.govAssistanceElibilityText + `</a>`;
      this.subscriptionService.messageCenterData$.next(
        {
          value: reverifySnapMessage,
          isErrorMsg: true,
        });
    } else {
      this.subscriptionService.messageCenterData$.next(
        {
          value: this.properties.manage.YOUR_FRESH_PASS_PLAN_IS,
          isErrorMsg: true,
        });
    }
  }

  checkNotifyMessage(): void {
    let text = localStorage.getItem(this.properties.manage.NOTIFY_MESSAGE);

    let messageJson = JSON.parse(text);

    if (messageJson && !messageJson.isDisplayed) {
      if (messageJson.message && messageJson.message.length > 0) {
        AB.COMMON.userNotify(messageJson.message);
      }
      messageJson.isDisplayed = true;
      text = JSON.stringify(messageJson);
      localStorage.setItem(this.properties.manage.NOTIFY_MESSAGE, text);
    }
  }

  getExpirationPlanType() {
    let expirationPlanType = '';
    if (this.userSubscriptionDetails.subscriptionType.toLowerCase().indexOf(this.properties.manage.MONTHLY.toLowerCase()) >= 0) {
      expirationPlanType = this.MONTHLY_PLAN_NAME;
    } else {
      expirationPlanType = this.ANNUAL_PLAN_NAME
    }
    return expirationPlanType;
  }

  getPlanType(subsCode) {
    if (subsCode === this.properties.manage.F9_B88_F7_E_5_F54_4536_AFC0_8_B080_D189_CDF) {
      return this.MONTHLY_PLAN_NAME
    } else {
      return this.ANNUAL_PLAN_NAME
    }
  }

  updateAnalyticsSubscriptionInfo() {
    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].updateAnalyticsSubscriptionInfo('manage', {});
    }
  }

  handleErrorCode(errorCode) {
    this.redirectToSubscribe();
  }

  shopAfterCancellation() {
    this.windowUtil.setWindowLocationHref('/shop/home.html');
  };

  removeTrailingZeroesInFee(fee: string): string {
    if (typeof fee !== 'string') {
      return fee;
    }
    if (fee.endsWith('.00')) {
      return fee.slice(0, -3);
    }
    return fee;
  }

  redirectToSubscribe() {
    const queryParams = this.activeRoute.snapshot.queryParams;
    this.router.navigate(['/freshpass/manage/subscribe'], { queryParams });
  }

  redirectIfNotPrimaryUser(userSubscriptionDetails) {
    if (userSubscriptionDetails?.isPrimaryFreshPassUser === false) {
      this.router.navigate([this.properties.urlPath.CONFIRMATION_PATH]);
    }
  }
}
